import type { SxProps, Theme } from '@mui/material';

export const DISABLED_TEXT_COLOR = '#a4adbe';

export const ADD_ERP_BUTTON_SX: SxProps<Theme> = {
  backgroundColor: '#f5f6fa',
  color: '#3788e6',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  boxShadow: 'none',
  borderRadius: '4px',
  padding: '6px 12px',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: '#e7ecf8',
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    marginRight: '4px',
  },
};

export const STEP_TITLE_SX: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
};

export const TABLE_CONTAINER_SX: SxProps<Theme> = {
  width: '100%',
  padding: '0 0 24px',
  boxSizing: 'border-box',
};

export const TEXT_ELLIPSIS_SX: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  width: '100%',
};

export const TABLE_SX = {
  border: '1px solid #e8ebf2',
  borderRadius: '10px',
  backgroundColor: '#ffffff',
  overflow: 'hidden',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f5f6fa',
    borderBottom: '1px solid #e8ebf2',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
    fontSize: '14px',
    color: '#020f20',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: 0,
  },
  '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox) .MuiDataGrid-columnHeaderTitleContainer':
    {
      padding: '0 16px',
    },
  '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-row': {
    borderBottom: '1px solid #e8ebf2',
  },
  '& .MuiDataGrid-row:last-child': {
    borderBottom: 'none',
  },
  '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
    backgroundColor: '#ffffff',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#f5f6fa',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid #e8ebf2',
    fontSize: '14px',
    color: '#1b3d55',
    padding: '0 16px',
  },
  '& .MuiDataGrid-cell:last-of-type': {
    paddingRight: '16px',
  },
  '& .MuiDataGrid-cellCheckbox': {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  '& .MuiCheckbox-root': {
    color: '#a4adbe',
  },
  '& .MuiCheckbox-root.Mui-checked': {
    color: '#07105f',
  },
} satisfies SxProps<Theme>;


